import { version } from "./version";
import { config } from "./config";

export const environment = {
  production: true,
  name: 'production',
  version: version,
  debug: false,
  api: 'https://server.congreet.com/api/v2',
  redirectUri: 'http://localhost/callback',
  assets: 'https://assets.congreet.com',
  pwa: config.pwa,
  deeplink: config.deeplink,
  availableLangs: config.availableLangs,
  liveTranslation: false,
  cookieForAssets: true,
  hideSidebarPublicPages: config.hideSidebarPublicPages,
  publicPagesLang: config.publicPagesLang,
  hideLogout: config.hideLogout,
  hideSettingsPasswordReset: config.hideSettingsPasswordReset,
  atsAnonymous: config.atsAnonymous,
  noIframeRediret: config.noIframeRediret,
  showInstallPrompt: config.showInstallPrompt,
  showCredentialWallet: config.showCredentialWallet,
  hideRatingInMembers: config.hideRatingInMembers,
  sameSiteAssets: config.sameSiteAssets,
  google: {
      apiKeys: {
          android: 'AIzaSyArTn4ZZsimCyTU4U776Ww1mxGicQwUEG4',
          ios: 'AIzaSyDhrhGJ_ft5cAKP4_ST_QK7L5Lk1JvwsCc',
          web: 'AIzaSyBagu5q2R6i-IvZ8y6xDT3tfDJNwOeb9ow'
      },
      apiKey: 'AIzaSyArTn4ZZsimCyTU4U776Ww1mxGicQwUEG4'
  },
  linkedIn: {
      clientId: '78vsq6ziw3gfkz'
      // clientId: '864jq9ftuk7dbs' // for mobile aps
  },
  sentry: {
      enabled: false,
      dialog: false,
      dsn: ''
  }
};
